import axios from "axios";

const hostname = window.location.hostname;

const isLocal =
  hostname === "localhost" ||
  hostname === "127.0.0.1";

const API_BASE_URL = isLocal
  ? "http://localhost:5002/api"
  : "/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// =========================================================
// REQUEST INTERCEPTOR
// =========================================================

api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("token") ||
      localStorage.getItem("accessToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// =========================================================
// RESPONSE INTERCEPTOR
// =========================================================

api.interceptors.response.use(
  (response) => response,

  (error) => {
    const requestUrl =
      error?.config?.url || "";

    const isChangePasswordRequest =
      requestUrl.includes(
        "/change-password"
      );

    /*
     * A wrong current password should NOT log
     * the user out.
     *
     * Other 401 responses continue to behave
     * as before.
     */
    if (
      error?.response?.status === 401 &&
      !isChangePasswordRequest
    ) {
      localStorage.removeItem("token");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("user");

      sessionStorage.removeItem(
        "authUser"
      );

      if (
        window.location.pathname !==
        "/login"
      ) {
        window.location.href =
          "/login";
      }
    }

    return Promise.reject(error);
  }
);

console.log("🚀 EDUCATION AXIOS CONFIG:", {
  hostname,
  isLocal,
  baseURL: API_BASE_URL,
});

export default api;